module.exports = __webpack_public_path__ + "media/images/p6-63eccf9d85e2bd113d94635db688a4ac.jpg";